import { render, staticRenderFns } from "./TemplateNavbar.vue?vue&type=template&id=32951980&scoped=true&"
import script from "./TemplateNavbar.vue?vue&type=script&lang=js&"
export * from "./TemplateNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TemplateNavbar.vue?vue&type=style&index=0&id=32951980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32951980",
  null
  
)

export default component.exports